import { AdminIndexTable } from "../components/AdminIndexTable";

function slugify(val: string): string {
    return val
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "")
        .replace(/-{2,}/g, "-")
        .replace(/^-|-$/g, "");
}

function bindAutoSlug(scope: HTMLElement): void {
    const nameEnInput = scope.querySelector<HTMLInputElement>("[data-menu-name-en]");
    const slugInput   = scope.querySelector<HTMLInputElement>("[data-menu-slug]");
    if (!nameEnInput || !slugInput) return;

    let userEdited = slugInput.value.trim() !== "";

    slugInput.addEventListener("input", () => {
        userEdited = slugInput.value.trim() !== "";
    });

    nameEnInput.addEventListener("input", () => {
        if (userEdited) return;
        slugInput.value = slugify(nameEnInput.value);
    });
}

export const AdminMenuController = {
    index(): void {
        new AdminIndexTable({ pageSelector: ".admin-menus" }).init();
    },
    form(): void {
        const page = document.querySelector<HTMLElement>(".admin-menu-form");
        if (page) bindAutoSlug(page);
    },
};
